import { render, staticRenderFns } from "./ResourceList.vue?vue&type=template&id=a82bf1e0&scoped=true"
import script from "./ResourceList.vue?vue&type=script&lang=js"
export * from "./ResourceList.vue?vue&type=script&lang=js"
import style0 from "./ResourceList.vue?vue&type=style&index=0&id=a82bf1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82bf1e0",
  null
  
)

export default component.exports